import {ApiCall} from "../helpers/api"

export default {
	loadCodeList(path, method = "GET", request) {
		return new ApiCall(path, method, request).call()
	}
}
